function trimTrailingSlash(value) {
  return value.replace(/\/+$/, "");
}

function inferApiBaseUrl() {
  const configured = process.env.REACT_APP_API;
  if (configured) return trimTrailingSlash(configured);

  if (typeof window === "undefined") return "";

  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:5109/api";
  }

  if (hostname === "jabburelias.com.br" || hostname.endsWith(".jabburelias.com.br")) {
    return "https://api.jabburelias.com.br/api";
  }

  return "";
}

export const API_BASE_URL = inferApiBaseUrl();

export function buildApiUrl(path) {
  if (!path) return API_BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;

  const cleanPath = String(path).replace(/^\/+/, "");
  return `${API_BASE_URL}/${cleanPath}`;
}

export function normalizeApiRequestUrl(url) {
  if (typeof url !== "string") return url;

  if (url === "undefined") {
    return API_BASE_URL;
  }

  if (url.startsWith("undefined/")) {
    return buildApiUrl(url.slice("undefined/".length));
  }

  return url;
}
